import { ref } from "vue";

/** Cache namespace only; the server still checks session ownership. */
export const agentSessionScope = ref<string | null>(null);
